export default __webpack_public_path__ + "static/media/support.ecfa7bc4.png";